
export default function Footer() {
  return (
    <footer className="bg-gray-100 text-gray-600 py-10">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center space-y-2 mb-6 text-sm">
          <p className="font-bold text-gray-800 text-base">株式会社マカン</p>
          <p>〒105-0004　東京都港区新橋2-4-5</p>
          <p>TEL.03-6205-8024</p>
          <p>適格請求書発行事業者登録番号　T3010401141496</p>
        </div>

        <div className="border-t border-gray-300 pt-6 flex flex-col md:flex-row items-center justify-center gap-4 text-xs text-gray-500">
          <a
            href="https://mkn24.shop/shop/privacy"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="hover:text-gray-800 transition-colors cursor-pointer underline"
          >
            プライバシーポリシー
          </a>
          <span className="hidden md:inline">|</span>
          <a
            href="https://www.mkn-24.jp/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-800 transition-colors cursor-pointer"
          >
            ©株式会社マカン All rights reserved.
          </a>
        </div>
      </div>
    </footer>
  );
}
